var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptecBcFav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.73 59.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c6c7c9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.35,0a21.91,21.91,0,0,0-2.57.1C42.7,2.63,53.15,13.26,53.15,26c0,14.62-13.78,26.48-30.77,26.48A34.29,34.29,0,0,1,5.25,48a35,35,0,0,0,26.1,11.14c18.44,0,33.38-13.23,33.38-29.57S49.79,0,31.35,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.86,30.21A24.53,24.53,0,0,1,39.12,7.58a25.92,25.92,0,0,0-14.39-4.3C11.07,3.28,0,13.57,0,26.26A22.35,22.35,0,0,0,9.08,44.05,24.65,24.65,0,0,1,4.86,30.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.83,10.62A21.72,21.72,0,0,1,46.11,22c0,14-13.82,25.38-30.86,25.38H15.2a26.64,26.64,0,0,0,9.43,1.72c13.72,0,24.84-10.26,24.84-22.91a21.86,21.86,0,0,0-6.64-15.58"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptecBcFav);
export default __webpack_public_path__ + "static/media/optec-bc-fav.38c634bb1e1f000355bd8061c5b35449.svg";
export { ForwardRef as ReactComponent };